export default "__VITE_ASSET__DYo$B1Dx__"